
const main_dialog = {
  namespaced: true,
  state:{
    main_dialog_isShow:false,//开关
    top:100,
    left:100,
    edit_name:'',//当前编辑的名称
    tabsName: 'style',
    tabs_name:'col'
  },
  mutations:{
    Change_main_dialog_isShow(state, val){
      state.main_dialog_isShow = val;
    },
    set_tabs_name (state, tabsName) {
      state.tabsName = tabsName
    },

    //设置打开位置
    Change_position(state, obj){
      state.top = obj.top;
      state.left = obj.left;
    },

    //设置编辑部件名称
    Change_edit_name(state, name){
      state.edit_name = name;
    },

    Change_tabs_name(state, name){
      state.tabs_name = name;
    },



  },
  actions:{


  }

};


export default main_dialog;



// WEBPACK FOOTER //
// ./src/vuex/modules/main_dialog.js